import React from "react";

import { motion } from "framer-motion";
import moment from "moment";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaDownload, FaGlobeAsia, MdCollections } from "../../assets/icons";
import {
  buttonClick,
  fadeInOut,
  imageWhileHover,
} from "../../utils/animations";
import { useStateValue } from "../../context/StateProvider";
import { Avatar } from "../../assets";

const FeedDetail = ({ index, data }) => {
  const [{ user }, dispatch] = useStateValue();
  return (
    <motion.div
      {...fadeInOut}
      className="w-full md:w-[390px] min-w-[300px] hover:shadow-md p-2 rounded-md flex items-start justify-start gap-2 flex-col cursor-pointer border border-gray-200"
    >
      <NavLink to={`/videoDetail/${data.concept_id}`}>
        <motion.div className="w-full rounded-md  bg-slate-100 overflow-hidden flex items-center justify-center">
          <motion.img
            {...imageWhileHover}
            src={data?.video_thumb}
            alt=""
            className="w-full md:h-225 md:min-h-[225px] object-cover rounded-md"
          />
        </motion.div>
      </NavLink>

      <div className="flex flex-col">
        <p className="text-textColor text-base font-semibold lowercase">
          {data.video_name.length > 48
            ? `${data.video_name.slice(0, 48)}...`
            : data.video_name}
        </p>
      </div>

      <div className=" w-full flex items-center justify-between">
        <div className="flex items-center justify-center gap-2">
          <img
            src={data.trainer?.thumb ? data.trainer?.thumb : Avatar}
            className="w-8 h-8 rounded-md object-cover"
            alt=""
            referrerPolicy="no-referrer"
          />
          <p className="text-base font-semibold text-textColor">
            {data.trainer?.name}
          </p>
        </div>
        {user && (
          <>
            {data?.liveURL.length > 0 && (
              <a href={data?.liveURL} target="_blank">
                <motion.button
                  {...buttonClick}
                  className="px-4 py-1 flex items-center justify-center gap-3 rounded-md border-none   outline-none cursor-pointer hover:shadow-md text-textColor"
                >
                  <FaGlobeAsia className=" -rotate-0 text-textColor" />
                </motion.button>
              </a>
            )}

            {data?.github.length > 0 && (
              <a href={data?.github} target="_blank">
                <motion.button
                  {...buttonClick}
                  className="px-4 py-1 flex items-center justify-center gap-3 rounded-md  border-none  outline-none cursor-pointer hover:shadow-md text-textColor"
                >
                  <FaDownload className=" -rotate-0 text-textColor" />
                </motion.button>
              </a>
            )}
          </>
        )}

        <p className="text-sm text-slate-600 -mt-1">
          {/* {moment(new Date(parseInt(data.concept_id)).toISOString()).fromNow()
            .length > 10 ? (
            <>{`${moment(new Date(parseInt(data.concept_id)).toISOString())
              .fromNow()
              .slice(0, 10)}...`}</>
          ) : (
            <>
              {moment(
                new Date(parseInt(data.concept_id)).toISOString()
              ).fromNow()}
            </>
          )} */}
          {moment(new Date(parseInt(data.concept_id)).toISOString()).fromNow()}
        </p>
      </div>
    </motion.div>
  );
};

export default FeedDetail;
